import { ClientData, ConsolidatedAccountData } from "@shared/types";

export type PortfolioAccountData = ConsolidatedAccountData &
  Partial<ClientData> & { isLoading?: boolean };

export enum AccountsSort {
  NAME = "Name",
  TOTAL = "Total",
  AVAILABLE = "Available",
  CHANGE = "Change",
}

export enum ConnectExchangeTabs {
  QUICK_CONNECT = "Quick Connect",
  API_KEYS = "Connect with API Keys",
}
